var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMxFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 0H0V341.3H513V0H342Z",
    fill: "#DC2339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H171V342H0V0Z",
    fill: "#11865D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 0H342V342H171V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8 171.2C195.8 192.8 207.3 212.9 226.1 223.7C231.9 227.1 239.3 225.1 242.7 219.3C246.1 213.5 244.1 206.1 238.3 202.7C227 196.2 220.1 184.2 220.1 171.2C220.1 164.5 214.7 159.1 208 159.1C201.3 159.1 195.8 164.5 195.8 171.2ZM289.2 222.3C306.7 211.2 317.2 191.9 317.2 171.2C317.2 164.5 311.8 159.1 305.1 159.1C298.4 159.1 293 164.5 293 171.2C293 183.6 286.7 195.2 276.2 201.9C270.5 205.4 268.7 212.8 272.1 218.6C275.5 224.4 283 226.1 288.8 222.7C288.8 222.5 289 222.4 289.2 222.3Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 195.5C269.921 195.5 280.8 179.203 280.8 159.1C280.8 138.997 269.921 122.7 256.5 122.7C243.08 122.7 232.2 138.997 232.2 159.1C232.2 179.203 243.08 195.5 256.5 195.5Z",
    fill: "#C59262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxFlag);
export default __webpack_public_path__ + "static/media/mx-flag.b4c4a9f90510d0c8c8d6fb75f8b5e911.svg";
export { ForwardRef as ReactComponent };